import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { App1Routes } from "./app.routing";
import { AppComponent } from "./app.component";
import { ModuleWithProviders } from "@angular/compiler/src/core";
import { ReviewExperienceLayoutComponent } from "./review-experience-layout/review-experience-layout.component";
import { ReviewImprovementComponent } from "./review-improvement/review-improvement.component";
import { ReviewExperienceComponent } from "./review-experience/review-experience.component";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
// import { StarRatingModule } from 'angular-star-rating';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { DataService } from "./dataService/data.service";
import { Routes, RouterModule } from "@angular/router";
import { StorageServiceModule } from "ngx-webstorage-service";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { OptinComponent } from "./optin/optin.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CampaignSmsTrackingComponent } from "./campaign-sms-tracking/campaign-sms-tracking.component";
import { OptoutComponent } from "./optout/optout.component";
import { CustomerAppointmentBookingComponent } from "./customer-appointment-booking/customer-appointment-booking.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { UiSwitchModule } from "ngx-toggle-switch";
import { DeleteAppoinementComponent } from "./delete-appoinement/delete-appoinement.component";
import { APP_BASE_HREF } from "@angular/common";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { CustomerBookAppointmentComponent } from "./customer-book-appointment/customer-book-appointment.component";
import { SharedModule } from "./shared/shared.module";
import { BookingComponent } from "./booking/booking.component";
import { BookingInquiryComponent } from "./booking-inquiry/booking-inquiry.component";
import { BookingConfirmationComponent } from "./booking-confirmation/booking-confirmation.component";
import { InquiryComponent } from "./inquiry/inquiry.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { ReviewImprovementTestComponent } from './review-improvement-test/review-improvement-test.component';
import { ReviewReplyComponent } from "./review-reply/review-reply.component";
import { AiReviewExperienceLegacyComponent } from "./ai-review-experience-legacy/ai-review-experience-legacy.component";
import { AiReviewExperienceDemoComponent } from "./ai-review-experience-demo/ai-review-experience-demo.component";
import { AiReviewExperienceVerticalComponent } from "./ai-review-experience-vertical/ai-review-experience-vertical.component";
import { AiReviewGenComponent } from "./ai-review-gen/ai-review-gen.component";
import { ThumbsPromptComponent } from "./ai-review-gen/thumbs-prompt/thumbs-prompt.component";
import { NegativeFeedbackComponent } from "./ai-review-gen/negative-feedback/negative-feedback.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    AppComponent,
    ReviewExperienceLayoutComponent,
    ReviewImprovementComponent,
    ReviewExperienceComponent,
    OptinComponent,
    CampaignSmsTrackingComponent,
    OptoutComponent,
    CustomerAppointmentBookingComponent,
    DeleteAppoinementComponent,
    CustomerBookAppointmentComponent,
    BookingComponent,
    BookingInquiryComponent,
    BookingConfirmationComponent,
    InquiryComponent,
    ReviewImprovementTestComponent,
    ReviewReplyComponent,
    AiReviewExperienceLegacyComponent,
    AiReviewExperienceDemoComponent,
    AiReviewExperienceVerticalComponent,
    AiReviewGenComponent,
    ThumbsPromptComponent,
    NegativeFeedbackComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(App1Routes, {
      useHash: false,
      relativeLinkResolution: "legacy",
    }),
    // NgxLoadingModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: "rgba(0,0,0,0.1)",
      backdropBorderRadius: "4px",
      primaryColour: "#ff0000", // first dot color
      secondaryColour: "#00ff00", // second dot color
      tertiaryColour: "#0000ff", //third dot color
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    // StarRatingModule,
    NgbModule,
    PerfectScrollbarModule,
    StorageServiceModule,
    HttpClientModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      maxOpened: 1,
      autoDismiss: true
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    UiSwitchModule,
    SharedModule,
    NgxSliderModule,
  ],
  providers: [DataService],
  bootstrap: [AppComponent],
})
export class AppModule {}
